import { create } from 'zustand';

import { createCommunicationReportActionsSlice } from './actions';
import type { CommunicationReportActionsStore } from './types';

export const useCommunicationReportActionsStore =
  create<CommunicationReportActionsStore>()((set, get, store) => ({
    ...createCommunicationReportActionsSlice(set, get, store),
  }));

export { CommunicationReportItemActionKind } from './types';
export type { CommunicationReportActionsStore };
